import React, { useEffect } from 'react';
import { useLocation, Routes, Route, useParams } from 'react-router-dom';
import loadable from '@loadable/component';

import {
  careeros,
  salesPacker,
  meduzza,
  seda,
  flamingo,
  textileGroup,
  services,
} from '../constants/urls';
import { BlogRoutes } from '../pages/BlogPosts/BlogRoutes';

const Loading = loadable(() => import('components/loading'));

const delayImport =
  (importFunc, ms = 1500) =>
  () =>
    Promise.all([importFunc(), new Promise((res) => setTimeout(res, ms))]).then(
      ([mod]) => mod,
    );

const Loadable = (loader) =>
  loadable(delayImport(loader), {
    fallback: <Loading />,
  });

const Home = Loadable(() => import('../pages/Home'));
const CareerOS = Loadable(() => import('../pages/CareerOS'));
const SalesPacker = Loadable(() => import('../pages/SalesPacker'));
const Meduzza = Loadable(() => import('../pages/Meduzza'));
const Seda = Loadable(() => import('../pages/Seda'));
const Flamingo = Loadable(() => import('../pages/Flamingo'));
const TextileGroup = Loadable(() => import('../pages/TextileGroup'));
const PrivacyPolicy = Loadable(() => import('../pages/PrivacyPolicy'));
const TermsAndConditions = Loadable(
  () => import('../pages/TermsAndConditions'),
);
const Services = Loadable(() => import('../pages/Services'));
const Works = Loadable(() => import('../pages/Works'));
const Contact = Loadable(() => import('../pages/Contact'));
const NotFoundPage = Loadable(() => import('../pages/NotFoundPage'));

const AppRoutes = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.body.style.overflow = 'auto';
    document.body.style.touchAction = 'auto';

    return () => {
      window.lastLocation = pathname;
    };
  }, [pathname]);

  return (
    <Routes>
      <Route index element={<Home />} />
      <Route path="contact" element={<Contact />} />
      <Route path="works" element={<Works />} />
      <Route path="blog/*" element={<BlogRoutes />} />
      <Route path={careeros} element={<CareerOS />} />
      <Route path={salesPacker} element={<SalesPacker />} />
      <Route path={meduzza} element={<Meduzza />} />
      <Route path={seda} element={<Seda />} />
      <Route path={flamingo} element={<Flamingo />} />
      <Route path={textileGroup} element={<TextileGroup />} />
      <Route path={services} element={<Services />} />
      <Route path="privacypolicy" element={<PrivacyPolicy />} />
      <Route path="termsandconditions" element={<TermsAndConditions />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default React.memo(AppRoutes);
